/*! https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/plugins/respimg/ls.respimg.min.js */
/*! lazysizes - v5.1.0 */
!(function (a, b) {
  if (a) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
    };
    (b = b.bind(null, a, a.document)),
      "object" == typeof module && module.exports
        ? b(require("lazysizes"))
        : a.lazySizes
        ? c()
        : a.addEventListener("lazyunveilread", c, !0);
  }
})("undefined" != typeof window ? window : 0, function (a, b, c) {
  "use strict";
  var d,
    e = c.cfg,
    f = b.createElement("img"),
    g = "sizes" in f && "srcset" in f,
    h = /\s+\d+h/g,
    i = (function () {
      var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        d = Array.prototype.forEach;
      return function () {
        var f = b.createElement("img"),
          g = function (b) {
            var c,
              d,
              f = b.getAttribute(e.srcsetAttr);
            f &&
              (d = f.match(a)) &&
              ((c = "w" == d[2] ? d[1] / d[3] : d[3] / d[1]),
              c && b.setAttribute("data-aspectratio", c),
              b.setAttribute(e.srcsetAttr, f.replace(h, "")));
          },
          i = function (a) {
            if (a.detail.instance == c) {
              var b = a.target.parentNode;
              b &&
                "PICTURE" == b.nodeName &&
                d.call(b.getElementsByTagName("source"), g),
                g(a.target);
            }
          },
          j = function () {
            f.currentSrc && b.removeEventListener("lazybeforeunveil", i);
          };
        b.addEventListener("lazybeforeunveil", i),
          (f.onload = j),
          (f.onerror = j),
          (f.srcset = "data:,a 1w 1h"),
          f.complete && j();
      };
    })();
  if (
    (e.supportsType ||
      (e.supportsType = function (a) {
        return !a;
      }),
    a.HTMLPictureElement && g)
  )
    return void (
      !c.hasHDescriptorFix &&
      b.msElementsFromPoint &&
      ((c.hasHDescriptorFix = !0), i())
    );
  a.picturefill ||
    e.pf ||
    ((e.pf = function (b) {
      var c, e;
      if (!a.picturefill)
        for (c = 0, e = b.elements.length; c < e; c++) d(b.elements[c]);
    }),
    (d = (function () {
      var f = function (a, b) {
          return a.w - b.w;
        },
        i = /^\s*\d+\.*\d*px\s*$/,
        j = function (a) {
          var b,
            c,
            d = a.length,
            e = a[d - 1],
            f = 0;
          for (f; f < d; f++)
            if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
              !e.cached &&
                (b = a[f - 1]) &&
                b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
                ((c = Math.pow(b.d - 0.6, 1.6)),
                b.cached && (b.d += 0.15 * c),
                b.d + (e.d - a.d) * c > a.d && (e = b));
              break;
            }
          return e;
        },
        k = (function () {
          var a,
            b = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
            c = /\s/,
            d = function (b, c, d, e) {
              a.push({ c: c, u: d, w: 1 * e });
            };
          return function (e) {
            return (
              (a = []),
              (e = e.trim()),
              e.replace(h, "").replace(b, d),
              a.length || !e || c.test(e) || a.push({ c: e, u: e, w: 99 }),
              a
            );
          };
        })(),
        l = function () {
          l.init ||
            ((l.init = !0),
            addEventListener(
              "resize",
              (function () {
                var a,
                  c = b.getElementsByClassName("lazymatchmedia"),
                  e = function () {
                    var a, b;
                    for (a = 0, b = c.length; a < b; a++) d(c[a]);
                  };
                return function () {
                  clearTimeout(a), (a = setTimeout(e, 66));
                };
              })()
            ));
        },
        m = function (b, d) {
          var f,
            g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
          !g &&
            d &&
            (g = b._lazypolyfill
              ? b._lazypolyfill._set
              : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
            (b._lazypolyfill && b._lazypolyfill._set == g) ||
              ((f = k(g || "")),
              d &&
                b.parentNode &&
                ((f.isPicture =
                  "PICTURE" == b.parentNode.nodeName.toUpperCase()),
                f.isPicture &&
                  a.matchMedia &&
                  (c.aC(b, "lazymatchmedia"), l())),
              (f._set = g),
              Object.defineProperty(b, "_lazypolyfill", {
                value: f,
                writable: !0,
              }));
        },
        n = function (b) {
          var d = a.devicePixelRatio || 1,
            e = c.getX && c.getX(b);
          return Math.min(e || d, 2.5, d);
        },
        o = function (b) {
          return a.matchMedia
            ? (o = function (a) {
                return !a || (matchMedia(a) || {}).matches;
              })(b)
            : !b;
        },
        p = function (a) {
          var b, d, g, h, k, l, p;
          if (((h = a), m(h, !0), (k = h._lazypolyfill), k.isPicture))
            for (
              d = 0,
                b = a.parentNode.getElementsByTagName("source"),
                g = b.length;
              d < g;
              d++
            )
              if (
                e.supportsType(b[d].getAttribute("type"), a) &&
                o(b[d].getAttribute("media"))
              ) {
                (h = b[d]), m(h), (k = h._lazypolyfill);
                break;
              }
          return (
            k.length > 1
              ? ((p = h.getAttribute("sizes") || ""),
                (p = (i.test(p) && parseInt(p, 10)) || c.gW(a, a.parentNode)),
                (k.d = n(a)),
                !k.src || !k.w || k.w < p
                  ? ((k.w = p), (l = j(k.sort(f))), (k.src = l))
                  : (l = k.src))
              : (l = k[0]),
            l
          );
        },
        q = function (a) {
          if (
            !g ||
            !a.parentNode ||
            "PICTURE" == a.parentNode.nodeName.toUpperCase()
          ) {
            var b = p(a);
            b &&
              b.u &&
              a._lazypolyfill.cur != b.u &&
              ((a._lazypolyfill.cur = b.u),
              (b.cached = !0),
              a.setAttribute(e.srcAttr, b.u),
              a.setAttribute("src", b.u));
          }
        };
      return (q.parse = k), q;
    })()),
    e.loadedClass &&
      e.loadingClass &&
      (function () {
        var a = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(
          function (b) {
            a.push(b + e.loadedClass), a.push(b + e.loadingClass);
          }
        ),
          e.pf({ elements: b.querySelectorAll(a.join(", ")) });
      })());
});

/* https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/plugins/parent-fit/ls.parent-fit.min.js */
/*! lazysizes - v5.1.0 */
!(function (a, b) {
  if (a) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
    };
    (b = b.bind(null, a, a.document)),
      "object" == typeof module && module.exports
        ? b(require("lazysizes"))
        : a.lazySizes
        ? c()
        : a.addEventListener("lazyunveilread", c, !0);
  }
})("undefined" != typeof window ? window : 0, function (a, b, c) {
  "use strict";
  if (a.addEventListener) {
    var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
      e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
      f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
      g = /^picture$/i,
      h = c.cfg,
      i = function (a) {
        return getComputedStyle(a, null) || {};
      },
      j = {
        getParent: function (b, c) {
          var d = b,
            e = b.parentNode;
          return (
            (c && "prev" != c) ||
              !e ||
              !g.test(e.nodeName || "") ||
              (e = e.parentNode),
            "self" != c &&
              (d =
                "prev" == c
                  ? b.previousElementSibling
                  : c && (e.closest || a.jQuery)
                  ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e
                  : e),
            d
          );
        },
        getFit: function (a) {
          var b,
            c,
            d = i(a),
            g = d.content || d.fontFamily,
            h = {
              fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit"),
            };
          return (
            !h.fit && g && (b = g.match(e)) && (h.fit = b[1]),
            h.fit
              ? ((c =
                  a._lazysizesParentContainer ||
                  a.getAttribute("data-parent-container")),
                !c && g && (b = g.match(f)) && (c = b[1]),
                (h.parent = j.getParent(a, c)))
              : (h.fit = d.objectFit),
            h
          );
        },
        getImageRatio: function (b) {
          var c,
            e,
            f,
            i,
            j,
            k,
            l,
            m = b.parentNode,
            n =
              m && g.test(m.nodeName || "")
                ? m.querySelectorAll("source, img")
                : [b];
          for (c = 0; c < n.length; c++)
            if (
              ((b = n[c]),
              (e =
                b.getAttribute(h.srcsetAttr) ||
                b.getAttribute("srcset") ||
                b.getAttribute("data-pfsrcset") ||
                b.getAttribute("data-risrcset") ||
                ""),
              (f = b._lsMedia || b.getAttribute("media")),
              (f = h.customMedia[b.getAttribute("data-media") || f] || f),
              e && (!f || ((a.matchMedia && matchMedia(f)) || {}).matches))
            ) {
              (i = parseFloat(b.getAttribute("data-aspectratio"))),
                i ||
                  ((j = e.match(d)),
                  j
                    ? "w" == j[2]
                      ? ((k = j[1]), (l = j[3]))
                      : ((k = j[3]), (l = j[1]))
                    : ((k = b.getAttribute("width")),
                      (l = b.getAttribute("height"))),
                  (i = k / l));
              break;
            }
          return i;
        },
        calculateSize: function (a, b) {
          var c,
            d,
            e,
            f,
            g = this.getFit(a),
            h = g.fit,
            i = g.parent;
          return "width" == h ||
            (("contain" == h || "cover" == h) && (e = this.getImageRatio(a)))
            ? (i ? (b = i.clientWidth) : (i = a),
              (f = b),
              "width" == h
                ? (f = b)
                : (d = i.clientHeight) > 40 &&
                  (c = b / d) &&
                  (("cover" == h && c < e) || ("contain" == h && c > e)) &&
                  (f = b * (e / c)),
              f)
            : b;
        },
      };
    (c.parentFit = j),
      b.addEventListener("lazybeforesizes", function (a) {
        if (!a.defaultPrevented && a.detail.instance == c) {
          var b = a.target;
          a.detail.width = j.calculateSize(b, a.detail.width);
        }
      });
  }
});

/*! https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/plugins/bgset/ls.bgset.min.js */
/*! lazysizes - v5.1.0 */
!(function (a, b) {
  var c = function () {
    b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
  };
  (b = b.bind(null, a, a.document)),
    "object" == typeof module && module.exports
      ? b(require("lazysizes"))
      : a.lazySizes
      ? c()
      : a.addEventListener("lazyunveilread", c, !0);
})(window, function (a, b, c) {
  "use strict";
  if (a.addEventListener) {
    var d = c.cfg,
      e = /\s+/g,
      f = /\s*\|\s+|\s+\|\s*/g,
      g = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
      h = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
      i = /\(|\)|'/,
      j = { contain: 1, cover: 1 },
      k = function (a) {
        var b = c.gW(a, a.parentNode);
        return (
          (!a._lazysizesWidth || b > a._lazysizesWidth) &&
            (a._lazysizesWidth = b),
          a._lazysizesWidth
        );
      },
      l = function (a) {
        var b;
        return (
          (b = (
            getComputedStyle(a) || { getPropertyValue: function () {} }
          ).getPropertyValue("background-size")),
          !j[b] && j[a.style.backgroundSize] && (b = a.style.backgroundSize),
          b
        );
      },
      m = function (a, b) {
        if (b) {
          var c = b.match(h);
          c && c[1]
            ? a.setAttribute("type", c[1])
            : a.setAttribute("media", d.customMedia[b] || b);
        }
      },
      n = function (a, c, h) {
        var i = b.createElement("picture"),
          j = c.getAttribute(d.sizesAttr),
          k = c.getAttribute("data-ratio"),
          l = c.getAttribute("data-optimumx");
        c._lazybgset &&
          c._lazybgset.parentNode == c &&
          c.removeChild(c._lazybgset),
          Object.defineProperty(h, "_lazybgset", { value: c, writable: !0 }),
          Object.defineProperty(c, "_lazybgset", { value: i, writable: !0 }),
          (a = a.replace(e, " ").split(f)),
          (i.style.display = "none"),
          (h.className = d.lazyClass),
          1 != a.length || j || (j = "auto"),
          a.forEach(function (a) {
            var c,
              e = b.createElement("source");
            j && "auto" != j && e.setAttribute("sizes", j),
              (c = a.match(g))
                ? (e.setAttribute(d.srcsetAttr, c[1]), m(e, c[2]), m(e, c[3]))
                : e.setAttribute(d.srcsetAttr, a),
              i.appendChild(e);
          }),
          j &&
            (h.setAttribute(d.sizesAttr, j),
            c.removeAttribute(d.sizesAttr),
            c.removeAttribute("sizes")),
          l && h.setAttribute("data-optimumx", l),
          k && h.setAttribute("data-ratio", k),
          i.appendChild(h),
          c.appendChild(i);
      },
      o = function (a) {
        if (a.target._lazybgset) {
          var b = a.target,
            d = b._lazybgset,
            e = b.currentSrc || b.src;
          if (e) {
            var f = c.fire(d, "bgsetproxy", {
              src: e,
              useSrc: i.test(e) ? JSON.stringify(e) : e,
            });
            f.defaultPrevented ||
              (d.style.backgroundImage = "url(" + f.detail.useSrc + ")");
          }
          b._lazybgsetLoading &&
            (c.fire(d, "_lazyloaded", {}, !1, !0), delete b._lazybgsetLoading);
        }
      };
    addEventListener("lazybeforeunveil", function (a) {
      var d, e, f;
      !a.defaultPrevented &&
        (d = a.target.getAttribute("data-bgset")) &&
        ((f = a.target),
        (e = b.createElement("img")),
        (e.alt = ""),
        (e._lazybgsetLoading = !0),
        (a.detail.firesLoad = !0),
        n(d, f, e),
        setTimeout(function () {
          c.loader.unveil(e),
            c.rAF(function () {
              c.fire(e, "_lazyloaded", {}, !0, !0),
                e.complete && o({ target: e });
            });
        }));
    }),
      b.addEventListener("load", o, !0),
      a.addEventListener(
        "lazybeforesizes",
        function (a) {
          if (
            a.detail.instance == c &&
            a.target._lazybgset &&
            a.detail.dataAttr
          ) {
            var b = a.target._lazybgset,
              d = l(b);
            j[d] &&
              ((a.target._lazysizesParentFit = d),
              c.rAF(function () {
                a.target.setAttribute("data-parent-fit", d),
                  a.target._lazysizesParentFit &&
                    delete a.target._lazysizesParentFit;
              }));
          }
        },
        !0
      ),
      b.documentElement.addEventListener("lazybeforesizes", function (a) {
        !a.defaultPrevented &&
          a.target._lazybgset &&
          a.detail.instance == c &&
          (a.detail.width = k(a.target._lazybgset));
      });
  }
});

/*! https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/plugins/object-fit/ls.object-fit.min.js */
/*! lazysizes - v5.1.0 */
!(function (a, b) {
  if (a) {
    var c = function (d) {
      b(a.lazySizes, d), a.removeEventListener("lazyunveilread", c, !0);
    };
    (b = b.bind(null, a, a.document)),
      "object" == typeof module && module.exports
        ? b(require("lazysizes"))
        : a.lazySizes
        ? c()
        : a.addEventListener("lazyunveilread", c, !0);
  }
})("undefined" != typeof window ? window : 0, function (a, b, c, d) {
  "use strict";
  function e(a) {
    var b = getComputedStyle(a, null) || {},
      c = b.fontFamily || "",
      d = c.match(m) || "",
      e = (d && c.match(n)) || "";
    return (
      e && (e = e[1]),
      { fit: (d && d[1]) || "", position: q[e] || e || "center" }
    );
  }
  function f() {
    if (!i) {
      var a = b.createElement("style");
      (i = c.cfg.objectFitClass || "lazysizes-display-clone"),
        b.querySelector("head").appendChild(a);
    }
  }
  function g(a) {
    var b = a.previousElementSibling;
    b &&
      c.hC(b, i) &&
      (b.parentNode.removeChild(b),
      (a.style.position = b.getAttribute("data-position") || ""),
      (a.style.visibility = b.getAttribute("data-visibility") || ""));
  }
  function h(a, b) {
    var d,
      e,
      h,
      j,
      k = c.cfg,
      l = function () {
        var b = a.currentSrc || a.src;
        b &&
          e !== b &&
          ((e = b),
          (j.backgroundImage =
            "url(" + (p.test(b) ? JSON.stringify(b) : b) + ")"),
          d || ((d = !0), c.rC(h, k.loadingClass), c.aC(h, k.loadedClass)));
      },
      m = function () {
        c.rAF(l);
      };
    (a._lazysizesParentFit = b.fit),
      a.addEventListener("lazyloaded", m, !0),
      a.addEventListener("load", m, !0),
      c.rAF(function () {
        var d = a,
          e = a.parentNode;
        "PICTURE" == e.nodeName.toUpperCase() && ((d = e), (e = e.parentNode)),
          g(d),
          i || f(),
          (h = a.cloneNode(!1)),
          (j = h.style),
          h.addEventListener("load", function () {
            var a = h.currentSrc || h.src;
            a && a != o && ((h.src = o), (h.srcset = ""));
          }),
          c.rC(h, k.loadedClass),
          c.rC(h, k.lazyClass),
          c.rC(h, k.autosizesClass),
          c.aC(h, k.loadingClass),
          c.aC(h, i),
          [
            "data-parent-fit",
            "data-parent-container",
            "data-object-fit-polyfilled",
            k.srcsetAttr,
            k.srcAttr,
          ].forEach(function (a) {
            h.removeAttribute(a);
          }),
          (h.src = o),
          (h.srcset = ""),
          (j.backgroundRepeat = "no-repeat"),
          (j.backgroundPosition = b.position),
          (j.backgroundSize = b.fit),
          h.setAttribute("data-position", d.style.position),
          h.setAttribute("data-visibility", d.style.visibility),
          (d.style.visibility = "hidden"),
          (d.style.position = "absolute"),
          a.setAttribute("data-parent-fit", b.fit),
          a.setAttribute("data-parent-container", "prev"),
          a.setAttribute("data-object-fit-polyfilled", ""),
          (a._objectFitPolyfilledDisplay = h),
          e.insertBefore(h, d),
          a._lazysizesParentFit && delete a._lazysizesParentFit,
          a.complete && l();
      });
  }
  var i,
    j = b.createElement("a").style,
    k = "objectFit" in j,
    l = k && "objectPosition" in j,
    m = /object-fit["']*\s*:\s*["']*(contain|cover)/,
    n = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
    o =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    p = /\(|\)|'/,
    q = { center: "center", "50% 50%": "center" };
  if (!k || !l) {
    var r = function (a) {
      if (a.detail.instance == c) {
        var b = a.target,
          d = e(b);
        return !(!d.fit || (k && "center" == d.position)) && (h(b, d), !0);
      }
    };
    a.addEventListener("lazybeforesizes", function (a) {
      if (a.detail.instance == c) {
        var b = a.target;
        null == b.getAttribute("data-object-fit-polyfilled") ||
          b._objectFitPolyfilledDisplay ||
          r(a) ||
          c.rAF(function () {
            b.removeAttribute("data-object-fit-polyfilled");
          });
      }
    }),
      a.addEventListener("lazyunveilread", r, !0),
      d && d.detail && r(d);
  }
});

/*! https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/lazysizes.min.js */
/*! lazysizes - v5.1.0 */
!(function (a, b) {
  var c = b(a, a.document);
  (a.lazySizes = c),
    "object" == typeof module && module.exports && (module.exports = c);
})("undefined" != typeof window ? window : {}, function (a, b) {
  "use strict";
  var c, d;
  if (
    ((function () {
      var b,
        c = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          autosizesClass: "lazyautosizes",
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          minSize: 40,
          customMedia: {},
          init: !0,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: !0,
          ricTimeout: 0,
          throttleDelay: 125,
        };
      d = a.lazySizesConfig || a.lazysizesConfig || {};
      for (b in c) b in d || (d[b] = c[b]);
    })(),
    !b || !b.getElementsByClassName)
  )
    return { init: function () {}, cfg: d, noSupport: !0 };
  var e = b.documentElement,
    f = a.Date,
    g = a.HTMLPictureElement,
    h = "addEventListener",
    i = "getAttribute",
    j = a[h],
    k = a.setTimeout,
    l = a.requestAnimationFrame || k,
    m = a.requestIdleCallback,
    n = /^picture$/i,
    o = ["load", "error", "lazyincluded", "_lazyloaded"],
    p = {},
    q = Array.prototype.forEach,
    r = function (a, b) {
      return (
        p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
        p[b].test(a[i]("class") || "") && p[b]
      );
    },
    s = function (a, b) {
      r(a, b) ||
        a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
    },
    t = function (a, b) {
      var c;
      (c = r(a, b)) &&
        a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
    },
    u = function (a, b, c) {
      var d = c ? h : "removeEventListener";
      c && u(a, b),
        o.forEach(function (c) {
          a[d](c, b);
        });
    },
    v = function (a, d, e, f, g) {
      var h = b.createEvent("Event");
      return (
        e || (e = {}),
        (e.instance = c),
        h.initEvent(d, !f, !g),
        (h.detail = e),
        a.dispatchEvent(h),
        h
      );
    },
    w = function (b, c) {
      var e;
      !g && (e = a.picturefill || d.pf)
        ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src),
          e({ reevaluate: !0, elements: [b] }))
        : c && c.src && (b.src = c.src);
    },
    x = function (a, b) {
      return (getComputedStyle(a, null) || {})[b];
    },
    y = function (a, b, c) {
      for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
        (c = b.offsetWidth), (b = b.parentNode);
      return c;
    },
    z = (function () {
      var a,
        c,
        d = [],
        e = [],
        f = d,
        g = function () {
          var b = f;
          for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
          a = !1;
        },
        h = function (d, e) {
          a && !e
            ? d.apply(this, arguments)
            : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
        };
      return (h._lsFlush = g), h;
    })(),
    A = function (a, b) {
      return b
        ? function () {
            z(a);
          }
        : function () {
            var b = this,
              c = arguments;
            z(function () {
              a.apply(b, c);
            });
          };
    },
    B = function (a) {
      var b,
        c = 0,
        e = d.throttleDelay,
        g = d.ricTimeout,
        h = function () {
          (b = !1), (c = f.now()), a();
        },
        i =
          m && g > 49
            ? function () {
                m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout);
              }
            : A(function () {
                k(h);
              }, !0);
      return function (a) {
        var d;
        (a = !0 === a) && (g = 33),
          b ||
            ((b = !0),
            (d = e - (f.now() - c)),
            d < 0 && (d = 0),
            a || d < 9 ? i() : k(i, d));
      };
    },
    C = function (a) {
      var b,
        c,
        d = 99,
        e = function () {
          (b = null), a();
        },
        g = function () {
          var a = f.now() - c;
          a < d ? k(g, d - a) : (m || e)(e);
        };
      return function () {
        (c = f.now()), b || (b = k(g, d));
      };
    },
    D = (function () {
      var g,
        l,
        m,
        o,
        p,
        y,
        D,
        F,
        G,
        H,
        I,
        J,
        K = /^img$/i,
        L = /^iframe$/i,
        M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent),
        N = 0,
        O = 0,
        P = 0,
        Q = -1,
        R = function (a) {
          P--, (!a || P < 0 || !a.target) && (P = 0);
        },
        S = function (a) {
          return (
            null == J && (J = "hidden" == x(b.body, "visibility")),
            J ||
              ("hidden" != x(a.parentNode, "visibility") &&
                "hidden" != x(a, "visibility"))
          );
        },
        T = function (a, c) {
          var d,
            f = a,
            g = S(a);
          for (
            F -= c, I += c, G -= c, H += c;
            g && (f = f.offsetParent) && f != b.body && f != e;

          )
            (g = (x(f, "opacity") || 1) > 0) &&
              "visible" != x(f, "overflow") &&
              ((d = f.getBoundingClientRect()),
              (g =
                H > d.left &&
                G < d.right &&
                I > d.top - 1 &&
                F < d.bottom + 1));
          return g;
        },
        U = function () {
          var a,
            f,
            h,
            j,
            k,
            m,
            n,
            p,
            q,
            r,
            s,
            t,
            u = c.elements;
          if ((o = d.loadMode) && P < 8 && (a = u.length)) {
            for (f = 0, Q++; f < a; f++)
              if (u[f] && !u[f]._lazyRace)
                if (!M || (c.prematureUnveil && c.prematureUnveil(u[f])))
                  aa(u[f]);
                else if (
                  (((p = u[f][i]("data-expand")) && (m = 1 * p)) || (m = O),
                  r ||
                    ((r =
                      !d.expand || d.expand < 1
                        ? e.clientHeight > 500 && e.clientWidth > 500
                          ? 500
                          : 370
                        : d.expand),
                    (c._defEx = r),
                    (s = r * d.expFactor),
                    (t = d.hFac),
                    (J = null),
                    O < s && P < 1 && Q > 2 && o > 2 && !b.hidden
                      ? ((O = s), (Q = 0))
                      : (O = o > 1 && Q > 1 && P < 6 ? r : N)),
                  q !== m &&
                    ((y = innerWidth + m * t),
                    (D = innerHeight + m),
                    (n = -1 * m),
                    (q = m)),
                  (h = u[f].getBoundingClientRect()),
                  (I = h.bottom) >= n &&
                    (F = h.top) <= D &&
                    (H = h.right) >= n * t &&
                    (G = h.left) <= y &&
                    (I || H || G || F) &&
                    (d.loadHidden || S(u[f])) &&
                    ((l && P < 3 && !p && (o < 3 || Q < 4)) || T(u[f], m)))
                ) {
                  if ((aa(u[f]), (k = !0), P > 9)) break;
                } else
                  !k &&
                    l &&
                    !j &&
                    P < 4 &&
                    Q < 4 &&
                    o > 2 &&
                    (g[0] || d.preloadAfterLoad) &&
                    (g[0] ||
                      (!p &&
                        (I ||
                          H ||
                          G ||
                          F ||
                          "auto" != u[f][i](d.sizesAttr)))) &&
                    (j = g[0] || u[f]);
            j && !k && aa(j);
          }
        },
        V = B(U),
        W = function (a) {
          var b = a.target;
          if (b._lazyCache) return void delete b._lazyCache;
          R(a),
            s(b, d.loadedClass),
            t(b, d.loadingClass),
            u(b, Y),
            v(b, "lazyloaded");
        },
        X = A(W),
        Y = function (a) {
          X({ target: a.target });
        },
        Z = function (a, b) {
          try {
            a.contentWindow.location.replace(b);
          } catch (c) {
            a.src = b;
          }
        },
        $ = function (a) {
          var b,
            c = a[i](d.srcsetAttr);
          (b = d.customMedia[a[i]("data-media") || a[i]("media")]) &&
            a.setAttribute("media", b),
            c && a.setAttribute("srcset", c);
        },
        _ = A(function (a, b, c, e, f) {
          var g, h, j, l, o, p;
          (o = v(a, "lazybeforeunveil", b)).defaultPrevented ||
            (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
            (h = a[i](d.srcsetAttr)),
            (g = a[i](d.srcAttr)),
            f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ""))),
            (p = b.firesLoad || ("src" in a && (h || g || l))),
            (o = { target: a }),
            s(a, d.loadingClass),
            p && (clearTimeout(m), (m = k(R, 2500)), u(a, Y, !0)),
            l && q.call(j.getElementsByTagName("source"), $),
            h
              ? a.setAttribute("srcset", h)
              : g && !l && (L.test(a.nodeName) ? Z(a, g) : (a.src = g)),
            f && (h || l) && w(a, { src: g })),
            a._lazyRace && delete a._lazyRace,
            t(a, d.lazyClass),
            z(function () {
              var b = a.complete && a.naturalWidth > 1;
              (p && !b) ||
                (b && s(a, "ls-is-cached"),
                W(o),
                (a._lazyCache = !0),
                k(function () {
                  "_lazyCache" in a && delete a._lazyCache;
                }, 9)),
                "lazy" == a.loading && P--;
            }, !0);
        }),
        aa = function (a) {
          if (!a._lazyRace) {
            var b,
              c = K.test(a.nodeName),
              e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
              f = "auto" == e;
            ((!f && l) ||
              !c ||
              (!a[i]("src") && !a.srcset) ||
              a.complete ||
              r(a, d.errorClass) ||
              !r(a, d.lazyClass)) &&
              ((b = v(a, "lazyunveilread").detail),
              f && E.updateElem(a, !0, a.offsetWidth),
              (a._lazyRace = !0),
              P++,
              _(a, b, f, e, c));
          }
        },
        ba = C(function () {
          (d.loadMode = 3), V();
        }),
        ca = function () {
          3 == d.loadMode && (d.loadMode = 2), ba();
        },
        da = function () {
          if (!l) {
            if (f.now() - p < 999) return void k(da, 999);
            (l = !0), (d.loadMode = 3), V(), j("scroll", ca, !0);
          }
        };
      return {
        _: function () {
          (p = f.now()),
            (c.elements = b.getElementsByClassName(d.lazyClass)),
            (g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass)),
            j("scroll", V, !0),
            j("resize", V, !0),
            a.MutationObserver
              ? new MutationObserver(V).observe(e, {
                  childList: !0,
                  subtree: !0,
                  attributes: !0,
                })
              : (e[h]("DOMNodeInserted", V, !0),
                e[h]("DOMAttrModified", V, !0),
                setInterval(V, 999)),
            j("hashchange", V, !0),
            [
              "focus",
              "mouseover",
              "click",
              "load",
              "transitionend",
              "animationend",
            ].forEach(function (a) {
              b[h](a, V, !0);
            }),
            /d$|^c/.test(b.readyState)
              ? da()
              : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)),
            c.elements.length ? (U(), z._lsFlush()) : V();
        },
        checkElems: V,
        unveil: aa,
        _aLSL: ca,
      };
    })(),
    E = (function () {
      var a,
        c = A(function (a, b, c, d) {
          var e, f, g;
          if (
            ((a._lazysizesWidth = d),
            (d += "px"),
            a.setAttribute("sizes", d),
            n.test(b.nodeName || ""))
          )
            for (
              e = b.getElementsByTagName("source"), f = 0, g = e.length;
              f < g;
              f++
            )
              e[f].setAttribute("sizes", d);
          c.detail.dataAttr || w(a, c.detail);
        }),
        e = function (a, b, d) {
          var e,
            f = a.parentNode;
          f &&
            ((d = y(a, f, d)),
            (e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b })),
            e.defaultPrevented ||
              ((d = e.detail.width) &&
                d !== a._lazysizesWidth &&
                c(a, f, e, d)));
        },
        f = function () {
          var b,
            c = a.length;
          if (c) for (b = 0; b < c; b++) e(a[b]);
        },
        g = C(f);
      return {
        _: function () {
          (a = b.getElementsByClassName(d.autosizesClass)), j("resize", g);
        },
        checkElems: g,
        updateElem: e,
      };
    })(),
    F = function () {
      !F.i && b.getElementsByClassName && ((F.i = !0), E._(), D._());
    };
  return (
    k(function () {
      d.init && F();
    }),
    (c = {
      cfg: d,
      autoSizer: E,
      loader: D,
      init: F,
      uP: w,
      aC: s,
      rC: t,
      hC: r,
      fire: v,
      gW: y,
      rAF: z,
    })
  );
});

/* https://raw.githubusercontent.com/aFarkas/lazysizes/gh-pages/plugins/unveilhooks/ls.unveilhooks.min.js */
/*! lazysizes - v5.2.2 */
!(function (e, t) {
  var a = function () {
    t(e.lazySizes), e.removeEventListener("lazyunveilread", a, !0);
  };
  (t = t.bind(null, e, e.document)),
    "object" == typeof module && module.exports
      ? t(require("lazysizes"))
      : "function" == typeof define && define.amd
      ? define(["lazysizes"], t)
      : e.lazySizes
      ? a()
      : e.addEventListener("lazyunveilread", a, !0);
})(window, function (e, n, i) {
  "use strict";
  var l,
    o,
    d = {};
  function u(e, t) {
    var a, r;
    d[e] ||
      ((a = n.createElement(t ? "link" : "script")),
      (r = n.getElementsByTagName("script")[0]),
      t ? ((a.rel = "stylesheet"), (a.href = e)) : (a.src = e),
      (d[e] = !0),
      (d[a.src || a.href] = !0),
      r.parentNode.insertBefore(a, r));
  }
  n.addEventListener &&
    ((l = function (e, t) {
      var a = n.createElement("img");
      (a.onload = function () {
        (a.onload = null), (a.onerror = null), (a = null), t();
      }),
        (a.onerror = a.onload),
        (a.src = e),
        a && a.complete && a.onload && a.onload();
    }),
    addEventListener(
      "lazybeforeunveil",
      function (e) {
        var t, a, r;
        if (e.detail.instance == i && !e.defaultPrevented) {
          var n = e.target;
          if (
            ("none" == n.preload &&
              (n.preload = n.getAttribute("data-preload") || "auto"),
            null != n.getAttribute("data-autoplay"))
          )
            if (n.getAttribute("data-expand") && !n.autoplay)
              try {
                n.play();
              } catch (e) {}
            else
              requestAnimationFrame(function () {
                n.setAttribute("data-expand", "-10"), i.aC(n, i.cfg.lazyClass);
              });
          (t = n.getAttribute("data-link")) && u(t, !0),
            (t = n.getAttribute("data-script")) && u(t),
            (t = n.getAttribute("data-require")) &&
              (i.cfg.requireJs ? i.cfg.requireJs([t]) : u(t)),
            (a = n.getAttribute("data-bg")) &&
              ((e.detail.firesLoad = !0),
              l(a, function () {
                (n.style.backgroundImage =
                  "url(" + (o.test(a) ? JSON.stringify(a) : a) + ")"),
                  (e.detail.firesLoad = !1),
                  i.fire(n, "_lazyloaded", {}, !0, !0);
              })),
            (r = n.getAttribute("data-poster")) &&
              ((e.detail.firesLoad = !0),
              l(r, function () {
                (n.poster = r),
                  (e.detail.firesLoad = !1),
                  i.fire(n, "_lazyloaded", {}, !0, !0);
              }));
        }
      },
      !(o = /\(|\)|\s|'/)
    ));
});

// (c) Copyright 2016 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus

(Shopify.arrayIncludes = function (e, t) {
  for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
  return !1;
}),
  (Shopify.uniq = function (e) {
    for (var t = [], n = 0; n < e.length; n++)
      Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
    return t;
  });

Shopify.updateOptionsInSelector = function (selectorIndex, $product) {
  var productOptionsMap = $product.data("om");

  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = $product.find(".product-variant:eq(0) .product-variants");
      break;
    case 1:
      var key = $product.find(".product-variant:eq(0) .product-variants").val();
      var selector = $product.find(".product-variant:eq(1) .product-variants");
      break;
    case 2:
      var key = $product.find(".product-variant:eq(0) .product-variants").val();
      key +=
        " / " + $product.find(".product-variant:eq(1) .product-variants").val();
      var selector = $product.find(".product-variant:eq(2) .product-variants");
  }

  var initialValue = selector.val();
  selector.empty();
  var availableOptions = productOptionsMap[key];
  $(".product-variant")
    .eq(selectorIndex)
    .find(".regular-select-item")
    .each(function () {
      $(this).removeClass("disabled");
      if ($.inArray($(this).data("value").toString(), availableOptions) < 0) {
        $(this).addClass("disabled");
      }
    });

  selector.find("option").each(function () {
    $(this).removeAttr("disabled", "disabled");
    if (!$.inArray($(this).val(), availableOptions)) {
      $(this).attr("disabled", "disabled");
    }
  });

  if (availableOptions) {
    for (var i = 0; i < availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = jQuery("<option></option>").val(option).html(option);
      selector.append(newOption);
    }
  }

  selector
    .parent()
    .find("ul li")
    .each(function () {
      $(this).removeClass("disabled");
      if ($.inArray($(this).text(), availableOptions) === -1) {
        $(this).addClass("disabled");
      }
    });

  $product
    .find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element')
    .each(function () {
      if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
        $(this)
          .removeClass("soldout")
          .show()
          .find(":radio")
          .removeAttr("disabled", "disabled")
          .removeAttr("checked");
      } else {
        $(this)
          .addClass("soldout")
          .hide()
          .find(":radio")
          .removeAttr("checked")
          .attr("disabled", "disabled");
      }
    });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger("change");
};

Shopify.linkOptionSelectors = function (product, $product) {
  var productOptionsMap = $product.data("om");
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      productOptionsMap["root"] = productOptionsMap["root"] || [];
      productOptionsMap["root"].push(variant.option1);
      productOptionsMap["root"] = Shopify.uniq(productOptionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        productOptionsMap[key] = productOptionsMap[key] || [];
        productOptionsMap[key].push(variant.option2);
        productOptionsMap[key] = Shopify.uniq(productOptionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        productOptionsMap[key] = productOptionsMap[key] || [];
        productOptionsMap[key].push(variant.option3);
        productOptionsMap[key] = Shopify.uniq(productOptionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0, $product);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, $product);
  if (product.options.length === 3)
    Shopify.updateOptionsInSelector(2, $product);
  // When there is an update in the first dropdown.
  $product.find(".product-variant:eq(0) .product-variants").change(function () {
    Shopify.updateOptionsInSelector(1, $product);
    if (product.options.length === 3)
      Shopify.updateOptionsInSelector(2, $product);
    return true;
  });
  // When there is an update in the second dropdown.
  $product.find(".product-variant:eq(1) .product-variants").change(function () {
    if (product.options.length === 3)
      Shopify.updateOptionsInSelector(2, $product);
    return true;
  });
};

// Custom variant option code
$(function () {
  var updateRadio = function () {
    $(this)
      .closest(".js-swatch-picker")
      .find(".js-swatch-value")
      .text($(this).attr("value"));
  };
  $(".js-swatch-radio").on("click", updateRadio);
  $(".js-swatch-radio").on("change", updateRadio);

  $("#product-tints").on("change", function () {
    var tintStyle = $(this).val();
    $("#swatch-picker").show();
    switch (tintStyle) {
      case "No Tint":
        $("#swatch-picker").hide();
        break;

      case "Mirror Tint":
        $(".js-swatch-wrapper").hide();
        $("#wrapper-tint-Blue").show();
        $("#wrapper-tint-Silver").show();
        $("#wrapper-tint-Gold").show();
        break;

      case "Graduated Tint":
        $(".js-swatch-wrapper").hide();
        $("#wrapper-tint-Graduated-Green").show();
        $("#wrapper-tint-Graduated-Gray").show();
        $("#wrapper-tint-Graduated-Brown").show();
        break;

      default:
        $(".js-swatch-wrapper").hide();
        $("#wrapper-tint-Green").show();
        $("#wrapper-tint-Grey").show();
        $("#wrapper-tint-Brown").show();
        break;
    }

    $("#swatch-picker")
      .find(".js-swatch-wrapper")
      .find(".js-swatch-radio")
      .prop("checked", false);
    var $target = $("#swatch-picker")
      .find(".js-swatch-wrapper:visible:first")
      .find(".js-swatch-radio");
    $target.prop("checked", true);
    $target
      .closest(".js-swatch-picker")
      .find(".js-swatch-value")
      .text($target.attr("value"));
  });

  $(".js-now-or-later-show").on("click", function () {
    $(".js-now-or-later-target").show(50);
  });

  $(".js-now-or-later-hide").on("click", function () {
    $(".js-now-or-later-target").hide(50);
  });

  $(".js-now-or-later-target#prescription").on("change", function () {
    $(".js-now-or-later-target#prescription_filename").val(
      $(".js-now-or-later-target#prescription").value
    );
  });

  const prescriptionInput = document.querySelector(
    ".js-now-or-later-target input#prescription"
  );
  const prescriptionFileName = document.querySelector(
    ".js-now-or-later-target input#prescription_filename"
  );

  if (!!prescriptionInput) {
    prescriptionInput.addEventListener("change", () => {
      prescriptionFileName.value = prescriptionInput.value.split("\\").pop();
      prescriptionFileName.classList.remove("hidden");
      prescriptionFileName.setAttribute(disabled, true);
    });
  }

  const togglePD = document.querySelector(".js-pd-checkbox");

  if (!!togglePD) {
    togglePD.addEventListener("change", () => {
      const toggledAreas = document.querySelectorAll(".js-pd-input");

      toggledAreas.forEach((area) => {
        area.classList.toggle("hidden");
        area.querySelector("input").value = null;
      });
    });
  }

  var $prlxModal = $(".js-prlx-modal");
  var $prlxModalClose = $(".js-prlx-modal-close");
  $infoSvg = $(
    '<svg viewBox="0 0 18 18"><defs><style>.b{fill:#191928;}</style></defs><path class="b" d="M9,0C4.03,0,0,4.03,0,9s4.03,9,9,9,9-4.03,9-9C17.99,4.03,13.97,0,9,0Zm-.17,4.15c.57,0,1.04,.46,1.04,1.04s-.46,1.04-1.04,1.04-1.04-.46-1.04-1.04,.46-1.04,1.04-1.04Zm.87,9.69h-.69c-.38,0-.69-.31-.69-.69v-4.15c-.38,0-.69-.31-.69-.69s.31-.69,.69-.69h.69c.38,0,.69,.31,.69,.69v4.15c.38,0,.69,.31,.69,.69s-.31,.69-.69,.69Z"/></svg>'
  );
  $infoSvg.appendTo('label[for="product-coating"]');
  $infoSvg.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $prlxModal.fadeIn();
    $("body").css("overflow", "hidden");
  });
  $prlxModalClose.on("click", function () {
    $prlxModal.fadeOut();
    $("body").css("overflow", "unset");
  });

  var $prlxTintModal = $(".js-prlx-modal-tint");
  var $prlxTintModalClose = $(".js-prlx-modal-tint-close");
  $infoSvgTint = $(
    '<svg viewBox="0 0 18 18"><defs><style>.b{fill:#191928;}</style></defs><path class="b" d="M9,0C4.03,0,0,4.03,0,9s4.03,9,9,9,9-4.03,9-9C17.99,4.03,13.97,0,9,0Zm-.17,4.15c.57,0,1.04,.46,1.04,1.04s-.46,1.04-1.04,1.04-1.04-.46-1.04-1.04,.46-1.04,1.04-1.04Zm.87,9.69h-.69c-.38,0-.69-.31-.69-.69v-4.15c-.38,0-.69-.31-.69-.69s.31-.69,.69-.69h.69c.38,0,.69,.31,.69,.69v4.15c.38,0,.69,.31,.69,.69s-.31,.69-.69,.69Z"/></svg>'
  );
  $infoSvgTint.appendTo('label[for="product-tints"]');
  $infoSvgTint.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $prlxTintModal.fadeIn();
    $("body").css("overflow", "hidden");
  });
  $prlxTintModalClose.on("click", function () {
    $prlxTintModal.fadeOut();
    $("body").css("overflow", "unset");
  });

  const watchVideo = document.querySelector(".js-watch-video");
  if (!!watchVideo) {
    watchVideo.addEventListener("click", (e) => {
      e.stopPropagation();
      var $prlxVideoModal = $(".js-prlx-modal-video");
      var $prlxVideoModalClose = $(".js-prlx-modal-close");

      $prlxVideoModal.fadeIn();
      $("body").css("overflow", "hidden");

      $prlxVideoModalClose.on("click", function () {
        $prlxVideoModal.fadeOut();
        $("body").css("overflow", "unset");
      });
    });
  }

 const addBtn = document.querySelector(".js-add-to-cart");

  if (!!addBtn) {
    const stickyBtn = document.querySelector(".js-sticky-cart");
    stickyBtn.querySelector('button').addEventListener('click', () => {
      addBtn.click();
    })

    const options = {
      threshold: 1,
    };

    const observer = new IntersectionObserver((entry) => {
      if (entry[0].isIntersecting === false) {
        stickyBtn.classList.add("is-active");
      } else {
        stickyBtn.classList.remove("is-active");
      }
    }, options);

    observer.observe(addBtn);
  }
});
